import {
    BaseCommentWithMentionsAndUser,
    CommentWithMentionsAndUser,
    DailyScrumCommentWithReplies,
    FeedbackCommentWithUser,
} from '@/common/types/databaseTypes';

// 타입 가드 함수들
function isCommentWithMentions(
    comment:
        | CommentWithMentionsAndUser
        | FeedbackCommentWithUser
        | DailyScrumCommentWithReplies
): comment is CommentWithMentionsAndUser {
    return (
        (comment as CommentWithMentionsAndUser).todo_id !== undefined ||
        (comment as CommentWithMentionsAndUser).goal_id !== undefined ||
        (comment as CommentWithMentionsAndUser).note_id !== undefined
    );
}

function isFeedbackComment(
    comment:
        | CommentWithMentionsAndUser
        | FeedbackCommentWithUser
        | DailyScrumCommentWithReplies
): comment is FeedbackCommentWithUser {
    return (comment as FeedbackCommentWithUser).feedback_id !== undefined;
}

function isDailyScrumComment(
    comment:
        | CommentWithMentionsAndUser
        | FeedbackCommentWithUser
        | DailyScrumCommentWithReplies
): comment is DailyScrumCommentWithReplies {
    return (
        (comment as DailyScrumCommentWithReplies).daily_scrum_item_id !==
        undefined
    );
}

// 어댑터 함수 개선
export function adaptComment(
    comment:
        | CommentWithMentionsAndUser
        | FeedbackCommentWithUser
        | DailyScrumCommentWithReplies
): BaseCommentWithMentionsAndUser {
    // 기본 공통 필드
    const baseComment: Partial<BaseCommentWithMentionsAndUser> = {
        id: comment.id,
        content: comment.content,
        user: comment.user,
    };

    // 타입에 따른 target_id 설정
    if (isCommentWithMentions(comment)) {
        // 기존 comment 테이블
        baseComment.target_id =
            comment.todo_id || comment.goal_id || comment.note_id;
        baseComment.target_type = comment.todo_id
            ? 'todo'
            : comment.goal_id
              ? 'goal'
              : 'note';
        baseComment.parent_id = comment.parent_id;
        baseComment.mentions = comment.mentions;

        // children 처리 (재귀)
        if (comment.children && comment.children.length > 0) {
            baseComment.children = comment.children.map(adaptComment);
        }
    } else if (isFeedbackComment(comment)) {
        // feedback_comment 테이블
        baseComment.target_id = comment.feedback_id;
        baseComment.target_type = 'feedback';
        baseComment.parent_id = comment.parent_comment_id;

        // feedback_comment에는 mentions가 아직 없으므로 빈 배열로 기본값 설정
        baseComment.mentions = [];
        //  (comment as FeedbackCommentWithUser).mentions || [];

        // children 처리 (재귀)
        if (comment.children && comment.children.length > 0) {
            baseComment.children = comment.children.map(adaptComment);
        }
    } else if (isDailyScrumComment(comment)) {
        // daily_scrum_comment 테이블
        baseComment.target_id = comment.daily_scrum_item_id;
        baseComment.target_type = 'daily_scrum';
        baseComment.parent_id = comment.parent_comment_id;

        // replies를 children으로 변환
        if (comment.replies && comment.replies.length > 0) {
            baseComment.children = comment.replies.map(adaptComment);
        }
    }

    // BaseFields 추가 (created_at, updated_at 등)
    const result: BaseCommentWithMentionsAndUser = {
        ...comment,
        ...baseComment,
        register_date: comment.register_date,
        update_date: comment.update_date,
        mentions: baseComment.mentions || [],
        target_id: baseComment.target_id || '',
        target_type: baseComment.target_type || 'note', // 기본값 설정
        parent_id: baseComment.parent_id || null,
    } as BaseCommentWithMentionsAndUser;

    return result;
}
